// window.intlTelInput = require('intl-tel-input/build/js/intlTelInput.min.js');
window.intlTelInput = require('intl-tel-input');

const input = document.querySelector("#phone");
const countryCodeInput = document.querySelector("#country_code");
const iti = window.intlTelInput(input, {
    separateDialCode: true,
    initialCountry: "my",
    preferredCountries: ["my"],
    hiddenInput: "phone_number",
    utilsScript: require("intl-tel-input/build/js/utils.js"),
});
// Set initial country's ISO code when the page loads
const initialCountryData = iti.getSelectedCountryData();
countryCodeInput.value = initialCountryData.iso2;

// Listen for country change
input.addEventListener('countrychange', function (e, countryData) {
    const selectedCountryData = iti.getSelectedCountryData();
    countryCodeInput.value = selectedCountryData.iso2;
});

function restrictNonNumeric(event) {
    const inputElement = event.target;
    const currentValue = inputElement.value;
    const onlyNumericValue = currentValue.replace(/[^0-9]/g, ''); // Replace any non-numeric characters with an empty string
    // const onlyNumericValue = currentValue.replace(/[^0-9+\-()\s#*]/g, '');
    ///[^0-9+\-()\s#*]/g used for sanitizing input to remove invalid characters
    //^[0-9+\-()\s#*]+$ used for strict validation to ensure the entire input consists of only valid characters.
  
    if (currentValue !== onlyNumericValue) {
        inputElement.value = onlyNumericValue;
    }
}

$('.btn-report-action').click(function(){
    $('#btn_report_action').val( $(this).val() );
});

$(document).ready(function() {
    $('#first_name, #last_name, #email, #phone').on("change paste keyup input", function(e){
        $(this).removeClass('is-invalid');
    });
    $('#phone').on('input', function(event) {
        restrictNonNumeric(event);
    });
});